import { useState,Suspense } from "react";
import  bigShoe1 from "./images/big-shoe1.png";
import  pierre from "./images/pierre-borthiry-peiobty-unsplash.jpg";
import HourglassTopIcon from '@mui/icons-material/HourglassTop';

export const isMobile = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(userAgent);
  // For iOS 13+ iPads, the user agent includes 'Macintosh' and has touch points
  const isIPad = /iPad/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isIPhone = /iPhone/i.test(userAgent);

  if (isAndroid) {
    console.log("Device is Android");
    // Your Android-specific code here
    return true;
  } else if (isIPad || isIPhone) {
    console.log("Device is iPad or iPhone (iOS)");
    // Your iOS-specific code here
    return true;
  } else {
    console.log("Device is neither a standard Android nor an iPad/iPhone");
    return false;
  }
}

const Hero = () => {
  const [bigShoeImg, setBigShoeImg] = useState(bigShoe1);
  //const [pierre, setPierre] = useState(pierre);
  const width = window.innerWidth
  const height = window.innerHeight
  const [isHovering, setIsHovering] = useState();
  
  const handleMouseEnter = () => {
    setIsHovering(true);

    console.log('Mouse entered');
  };
  // const [mobile , setMob]  = useState(false);
  // useEffect(()=>{
  //   setMob(isMobile());
  // },[])


  const handleMouseLeave = () => {
    setIsHovering(false);
    console.log('Mouse left');
  };
  return (
    <>
    <div
      id='home'
      style={{height:'700px',width:'100%', justifyContent:isMobile() ?"center":""}}
      className='bg-gray-200 h-20 rounded-md border-4 p-6 text-black flex-container flex-container-mobile'
    >
   {isMobile() ?<>
   {/* <div style={{display:"flex", justifyContent:"center"}}> */}
    <div style={{width:'50%'}} className='flex flex-col justify-center items-start w-full pt-28'>
      <div style={{paddingTop:'100px'}}></div>
        <p className='hover-text-hero text-xl font-montserrat text-coral-red'>
        </p>
        <h1 className='hover-text-hero mt-10 font-palanquin mobile-font text-8xl max-sm:text-[72px] font-bold'>
          <span className='hover-text-hero xl:whitespace-nowrap relative z-10 pr-10'>
            The New Way
          </span>
          <br />
          <span className='hover-text-hero text-coral-red inline-block mt-3'>To monitor</span> Your crypto Assets
        </h1>
        <p className='hover-text-hero font-montserrat text-slate-gray text-lg mt-6 mb-14 sm:max-w-sm'>
          Discover The Blockchain, monitor your 
          transactions in the WEB 3 network
        </p>
        <div style={{paddingTop:'200px'}}></div>
      </div>
   {/* </div> */}

   </> :
    <>
      <div style={{width:'50%'}} className='flex flex-col justify-center items-start w-full pt-28'>
      <div style={{paddingTop:'100px'}}></div>
        <p className='hover-text-hero text-xl font-montserrat text-coral-red'>
        </p>
        <h1 className='hover-text-hero mt-10 font-palanquin mobile-font text-8xl max-sm:text-[72px] font-bold'>
          <span className='hover-text-hero xl:whitespace-nowrap relative z-10 pr-10'>
            The New Way
          </span>
          <br />
          <span className='hover-text-hero text-coral-red inline-block mt-3'>To monitor</span> Your crypto Assets
        </h1>
        <p className='hover-text-hero font-montserrat text-slate-gray text-lg mt-6 mb-14 sm:max-w-sm'>
          Discover The Blockchain, monitor your 
          transactions in the WEB 3 network
        </p>
        <div style={{paddingTop:'200px'}}></div>
      </div>
    </>
    
    }


      {isMobile() ?<></> :
      <div style={{width:'40%',paddingTop:'150px',paddingLeft:'90px'}}className='rounded-xl mobile-hero-container'>
      <Suspense fallback={<div><HourglassTopIcon/></div>}>
        <img
          style={{borderRadius:'10px' , zIndex:9}}
          src={pierre}
          alt='shoe colletion'
          width={width/3}
          height={width/3}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className='rounded-xl mobile-hero rotate-on-hover object-contain relative z-10'
        />
      </Suspense>
       <div className={"bg-gray-200"} style={{paddingTop:'100px'}}></div> 
      </div>      
      }
     
    </div>     
    </>
 


  );
};

export default Hero;